import { FaUserAstronaut } from "react-icons/fa"

const AvatarHelper = () => (
  <span className="relative flex items-center justify-center h-24 w-24 m-4 bg-slate-300 text-slate-500 rounded-full">
    <FaUserAstronaut size="56" />
  </span>
)

export default AvatarHelper
